import ReportsAPI from 'dashboard/api/reports';
import camelcaseKeys from 'camelcase-keys';

export const initialState = {
  agentRecords: [],
  conversationRecords: [],
  conversationsTotal: 0,
  uiFlags: {
    isFetchingAgents: false,
    isFetchingConversations: false,
  },
};

export const getters = {
  getAgentRecords(state) {
    return state.agentRecords;
  },
  getConversationRecords(state) {
    return state.conversationRecords;
  },
  getConversationsTotal(state) {
    return state.conversationsTotal;
  },
  getUIFlags(state) {
    return state.uiFlags;
  },
};

export const actions = {
  async fetchAgents({ commit }, { since, until } = {}) {
    commit('setUIFlags', { isFetchingAgents: true });
    try {
      const response = await ReportsAPI.getRawAgentsReport({ since, until });
      const payload = camelcaseKeys(response.data, { deep: true });
      commit('setAgentRecords', payload.data);
    } finally {
      commit('setUIFlags', { isFetchingAgents: false });
    }
  },
  async fetchConversations({ commit }, { since, until } = {}) {
    commit('setUIFlags', { isFetchingConversations: true });
    try {
      const response = await ReportsAPI.getRawConversationsReport({
        since,
        until,
      });
      const payload = camelcaseKeys(response.data, { deep: true });
      commit('setConversationRecords', payload);
    } finally {
      commit('setUIFlags', { isFetchingConversations: false });
    }
  },
};

export const mutations = {
  setAgentRecords(state, data) {
    state.agentRecords = data;
  },
  setConversationRecords(state, { data, meta }) {
    state.conversationRecords = data;
    state.conversationsTotal = meta.total;
  },
  setUIFlags(state, uiFlags) {
    state.uiFlags = { ...state.uiFlags, ...uiFlags };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
